import { PedOverlaySection } from '~/shared';
import lipstick from '~/assets/icons/lipstick.svg';
import makeup from '~/assets/icons/makeup.svg';
import blush from '~/assets/icons/blush.svg';

export const makeupSections = [
	PedOverlaySection.Makeup,
	PedOverlaySection.Blush,
	PedOverlaySection.Lipstick,
];

export const skinSections = [
	PedOverlaySection.Blemishes,
	PedOverlaySection.Ageing,
	PedOverlaySection.Complexion,
	PedOverlaySection.SunDamage,
	PedOverlaySection.MolesFreckles,
];

export const makeupIcons: Partial<Record<PedOverlaySection, string>> = {
	[PedOverlaySection.Makeup]: makeup,
	[PedOverlaySection.Blush]: blush,
	[PedOverlaySection.Lipstick]: lipstick,
};
